import { Origin, PublicPath, SocialId } from '@/utils/constant';

export default function share(social: SocialId, keepQuery = true, result = false): string {
    let href = Origin + PublicPath;

    if (href && result) {
        const url = new URL(href);
        url.pathname += '/result';
        href = url.href;
    }

    const url = encodeURIComponent(keepQuery ? href : href.split('?')[0]);

    switch (social) {
        case SocialId.Fb:
            return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        case SocialId.Tw:
            return `https://twitter.com/share?url=${url}`;
        case SocialId.Ok:
            return `https://connect.ok.ru/offer?url=${url}`;
        case SocialId.Vk:
            return `https://vk.com/share.php?url=${url}`;
        case SocialId.Tg:
            return `https://t.me/share/url?url=${url}`;
        default:
            return '';
    }
}
